import { useAtom } from 'jotai';
import { PrimitiveAtom } from 'jotai/index';
import prettyBytes from 'pretty-bytes';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressBar } from 'primereact/progressbar';
import { useRef } from 'react';
import { BqTag } from '~/components/ui/misc/bqTag/BqTag';
import {
  FileStore,
  FileStoreStatus,
} from '~/components/ui/uploaderQueue/useQueue';
const filestatustoBqTag = (status: FileStoreStatus) => {
  switch (status) {
    case 'idle':
      return 'warn';
    case 'uploading':
      return 'info';
    case 'error':
      return 'danger';
    case 'complete':
      return 'success';
    default:
      return 'info';
  }
};
// export const FileUploadItem = ({
//     file,progress,size,fileName,fileType,status,retries,id,idx
//                                }: FileStore) => {
export type FileUploadItemProps = {
  fileAtom: PrimitiveAtom<FileStore>;
  // onStartUpload: (id: string, ) => void;
};
export const FileUploadItem = ({
  fileAtom,
}: {
  fileAtom: PrimitiveAtom<FileStore>;
}) => {
  const [fileStore] = useAtom(fileAtom);
  const op = useRef<OverlayPanel | null>(null);

  return (
    <div className="bq-file-upload-item">
      <OverlayPanel ref={op} dismissable showCloseIcon>
        {fileStore.status === 'error' && (
          <div className="error-details mb-2 p-2 border-round">
            {fileStore.errorType && (
              <div className="error-type mb-1 text-sm">
                <strong>Error Type:</strong> {fileStore.errorType}
              </div>
            )}
            {fileStore.error && (
              <div className="error-message text-sm">
                <strong>Message:</strong> {fileStore.error}
              </div>
            )}
          </div>
        )}
        {fileStore.responseCode && (
          <span className="mr-2 text-sm">
            <strong className="mr-2">Code:</strong> {fileStore.responseCode}
          </span>
        )}
        <span className="text-sm">
          <strong>Retries:</strong> {fileStore.retries}
        </span>
      </OverlayPanel>
      <div
        className="bq-file-upload-item-name"
        aria-label={fileStore?.fileName}
      >
        {fileStore?.fileName}
      </div>
      <div className="bq-file-upload-item-info mt-2">
        <div className="bq-file-upload-item-size">
          {prettyBytes(fileStore?.size)}
        </div>
        {/*<div className='bq-file-upload-item-size'>{fileStore?.fileType}</div>*/}

        <span
          className="cursor-pointer"
          onClick={(e) => {
            op.current?.toggle(e);
          }}
        >
          <BqTag
            color={filestatustoBqTag(fileStore?.status)}
            value={fileStore?.status}
          />
          {fileStore.status === 'error' && (
            <i className="pi pi-exclamation-circle ml-1 text-red-500" />
          )}
        </span>
      </div>
      <ProgressBar
        value={fileStore?.progress}
        style={{ height: '6px' }}
        className="mt-2"
        showValue={false}
      />
    </div>
  );
};
